import {useQuery} from "@tanstack/react-query";
import getUserProfile from "../api/getProfilePhoto";

const useGetUserProfile = () => {
  const {
    data: userProfileData,
    isLoading,
    isError,
    error,
    isFetching,
    refetch,
  } = useQuery({
    queryKey: ["getUserProfile"],
    queryFn: getUserProfile,
  });

  return {
    isLoading,
    userProfileData,
    refetch,
    isFetching,
    isError,
    error,
  };
};

export default useGetUserProfile;
